export default __webpack_public_path__ + "static/menu-image-314670531632b3b128e5e64f0b022735.svg";